import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./styles/login.css";
import phonePNG from "../assets/img/phone.png";
import passwdPNG from "../assets/img/passwd.png";
import { login } from "../action/user";
import { pushNotificationUtil } from "../utils/pushNotificationUtil";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import PublicFooter from "./PublicFooter";

const Login = () => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async () => {
    const loginSuccess = await dispatch(login(phone, password));
    if (loginSuccess) {
      // Привязка Telegram — только по явному действию в Профиле (без автопривязки)
      // Запрашиваем разрешение на уведомления
      if (pushNotificationUtil.isSupported()) {
        await pushNotificationUtil.requestPermission();
        await pushNotificationUtil.registerServiceWorker();
      }
      navigate("/main");
    }
  };

  return (
    <div className="auth-page">
    <div className="auth">
      <div className="form">
        <LanguageSwitcher compact />
        <h1 className="h1-auth">{t('auth.loginTitle')}</h1>
        <p className="auth-subtitle">{t('auth.loginSubtitle')}</p>

        <div className="input__div">
          <img src={phonePNG} alt="Phone" className="phonePNG" />
          <input
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
            type="tel"
            className="input"
            placeholder="8XXXXXXXXXX"
          />
        </div>

        <div className="input__div">
          <img src={passwdPNG} alt="Password" className="phonePNG" />
          <input
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            className="input"
            placeholder="******"
          />
        </div>

        <button className="buttonLogin" onClick={handleLogin}>
          {t('auth.login')}
        </button>

        <Link to="/forgot-password" className="link__auth">
          {t('auth.forgot')}
        </Link>

        <Link to="/registration" className="link__auth">
          {t('auth.noAccount')}
        </Link>

        <Link to="/public-offer" className="link__auth" style={{ fontSize: 13, opacity: 0.8 }}>
          {t('auth.offer')}
        </Link>
      </div>
    </div>
    <PublicFooter />
    </div>
  );
};

export default Login;
